export const markNotificationUnseen = async (id) => {
  await new Promise((resolve) => setTimeout(resolve, 300))
  console.log('Notification ' + id + ' would now be set to "Unseen" in the db')
}
